import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertLevel, AlertCategories, AlertState } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class TooManyAlerts extends AlertLogic {
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.SYSTEM_INFO ];
    static title = Locale.gettext('Repeated Errors Detected');
    static type = AlertType.TooManyAlerts;

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: TooManyAlerts.title,
            cardDescription: this.locale.gettext('Device "%s" has reported multiple operating errors today', device?.Name),
            cardIllustration: 'pipes_emergency',
            detailIcon: 'alert',
            detailDescriptionArr: [
                Locale.gettext('The device "%s" has reported multiple errors today.', device?.Name),
                Locale.gettext('To prevent repeated notifications, further alerts from this device have been temporarily silenced for the rest of the day.'),
                Locale.gettext('You can review all reported issues in the Alerts and History screen.'),
                Locale.gettext('Important: This does not mean the problem is resolved. The device may still have a serious issue that could impact safe and reliable operation. It should be inspected by a qualified pool professional as soon as possible.'),
                Locale.gettext('After the issue is resolved and 24 hours have passed without additional errors, this alert will clear and normal notifications will resume.')
            ],
        });
        alertInfo.contentCategories = TooManyAlerts.contentCategories;
        return alertInfo;
    } 

    static mock(type: AlertType, config: Config.AllConfig): AlertRecord {
        const device = config?.Config?.Devices?.find(dev => dev.DeviceType === Config.DeviceTypes.PUMP);
        if (!device) throw new Error(`Create a Pump to mock ${type} alert.`);

        return new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            level: AlertLevel.Fatal,
            state: AlertState.Open,
            type,
            data: {
                DriveErrorState: "UNKNOWN",
                ErrorStartTime: new Date().toISOString(),
                ErrorCode: 1
            }
            /*
            "deviceId": 733,
            "bodyUuid": null,
            "closedBy": null,
            "created": "2025-12-19T15:45:49.000Z",
            "updated": "2025-12-19T15:45:50.000Z",
            "site": {
                "shared": false,
                "online": null,
                "id": 610,
                "userId": 357,
                "uuid": "1b23e42d-c23e-4ee0-aa4c-b45e88fd8054",
                "name": "Eric’s v4 Test Unit 3",
                "country": "United States",
                "state": "Pennsylvania",
                "city": "Spinnerstown",
                "address": "",
                "zip": "",
                "latitude": "40.43906300000000",
                "longitude": "-75.43717300000000",
                "manualFiltering": true,
                "maintainerId": 22,
                "maintainerLocationUuid": "3a7279fa-7463-4077-be46-7641d01c72ce",
                "exportForAssistants": false,
                "created": "2025-08-21T15:55:49.000Z",
                "lastSeen": "2025-12-19T16:00:07.000Z",
                "deleted": 0,
                "monitored": false,
                "version": "c1c1b321c9c39532300566ba6b18f662089006e2",
                "versionName": "2.3.20",
                "timezone": "Pacific/Honolulu",
                "trainingVisit": null,
                "trainingTech": null,
                "vip": false,
                "noAutoUpdate": false
            },
            "device": {
                "online": null,
                "vpnHandler": null,
                "id": 733,
                "userId": null,
                "siteId": 610,
                "deviceNumber": 1,
                "uuid": "e9ea8592-50e9-4985-94d3-62b60ec21669",
                "model": "Attendant",
                "serial": "1000051780045",
                "vpnPublicKey": "Je39O7qx29NO7MlOoB7MJt1E8tBcccjWRTffUAz7hj0=",
                "vpnAddress": "10.0.1.94/32",
                "created": "2025-08-21T15:54:32.000Z",
                "lastSeen": "2025-12-19T16:00:07.000Z",
                "lastIp": "72.94.167.5",
                "version": "c1c1b321c9c39532300566ba6b18f662089006e2",
                "versionName": "2.3.20",
                "sku": null,
                "qaDate": null,
                "qaBatch": null,
                "qaUser": null,
                "shippingDate": null,
                "shippingTo": null,
                "shippingId": null,
                "distributorLocationUuid": null,
                "distributorPo": null,
                "poolsideInvoiceNumber": null,
                "poolsideInvoiceDate": null,
                "tryMe": false,
                "demoUnit": false
            }
            */
        });
    }
}